import apiClient from './base.api'
const BASE_ENDPOINT = window.config.SUBSCRIPTION_BASE_ENDPOINT

export const fetchPlansAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}plans`)
  return response
}

export const fetchDiscountsAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}discounts`)
  return response
}

export const getUserSubscriptionsAsync = async() => {
  const response = await apiClient.get(`${BASE_ENDPOINT}subscriptions/`)
  return response
}

export const updateSubscriptionAsync = async(subscriptionId, data) => {
  const response = await apiClient.patch(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/update/`, data)
  return response
}

export const cancelSubscriptionAsync = async(subscriptionId) => {
  const response = await apiClient.delete(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/`)
  return response
}

export const fetchAvailablePlansAsync = async(params = {}) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}catalog/`, { params })
  return response
}

export const createTransactionAsync = async(data) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}create-transaction/`, data)
  return response
}

export const deleteSubscriptionAsync = async(subscriptionId) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/cancel/`)
  return response
}

export const activateAutoRenewalAsync = async(subscriptionId) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/activate-auto-renewal/`)
  return response
}

export const getUpdatePaymentMethodTransactionAsync = async(subscriptionId) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/update-payment-method-transaction/`)
  return response
}

export const getProductsAsync = async(min_rank = null) => {
  const params = {}
  if (min_rank !== null) {
    params.min_rank = min_rank
  }
  const response = await apiClient.get(`${BASE_ENDPOINT}products/`, { params })
  return response
}

export const updateSubscriptionPreviewAsync = async(subscriptionId, data) => {
  const response = await apiClient.patch(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/preview-update/`, data)
  return response
}

export const resumeSubscriptionAsync = async(subscriptionId) => {
  const response = await apiClient.post(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/resume/`)
  return response
}

export const previewResumeSubscriptionAsync = async(subscriptionId) => {
  const response = await apiClient.get(`${BASE_ENDPOINT}subscriptions/${subscriptionId}/preview-resume/`)
  return response
}

